import iconIncidentBehaviour from "@/assets/icons/icon-incident-behaviour-white.svg";
import iconIncidentFire from "@/assets/icons/icon-incident-fire-white.svg";
import iconIncidentMedical from "@/assets/icons/icon-incident-medical-white.svg";
import iconIncidentShooter from "@/assets/icons/icon-incident-shooter-white.svg";
// SOS is the one incident type without custom designer artwork — it is the
// Font Awesome Pro `person-circle-exclamation` glyph exported as an asset so it
// stays interchangeable with the others at every call site.
import iconIncidentSos from "@/assets/icons/icon-incident-sos-white.svg";
import iconIncidentWeather from "@/assets/icons/icon-incident-weather-white.svg";

const incidentIcons = {
    behaviour: iconIncidentBehaviour,
    fire: iconIncidentFire,
    medical: iconIncidentMedical,
    shooter: iconIncidentShooter,
    sos: iconIncidentSos,
    weather: iconIncidentWeather,
};

export {
    iconIncidentBehaviour,
    iconIncidentFire,
    iconIncidentMedical,
    iconIncidentShooter,
    iconIncidentSos,
    iconIncidentWeather,
    incidentIcons,
};
